import { VisualBrick, registerBrick } from 'olympe';
import * as React from 'react';
import ReactDOM from 'react-dom';
import {RadioGroup, FormControlLabel, FormControl, FormLabel, Radio} from '@mui/material';

export default class SKURadioButtonGroup extends VisualBrick {

    /**
     * This method runs when the brick is ready in the HTML DOM.
     * @override
     * @param {!BrickContext} context
     * @param {!Element} elementDom
     */
    draw(context, elementDom) {
      const selectedValue = context.getProperty('selected-value')
      const title = context.getProperty('title')

      const handleChange = (event) => {
        selectedValue.set(event.target.value)
      };


        ReactDOM.render(<SKURadioButtonGroup.Component
          selectedValue={selectedValue}
          title={title}
          handleChange={handleChange}
          />, elementDom);
        /* Write your code here. You have to implement this method ! */
    }
}

SKURadioButtonGroup.Component = ({ selectedValue, title, handleChange }) => {

    const [value, setValue] = React.useState('')

    React.useEffect(() => {
      selectedValue.observe().subscribe(setValue)
    }, [])

    return (
        <FormControl component="fieldset">
            <FormLabel component="legend" sx={{
                '&.Mui-focused': {
                    color: '#f19100',
                }
            }}>{title.get()}</FormLabel>
            <RadioGroup
              name="radio-buttons-group"
              value={value}
              onChange={handleChange}
              sx={{display:'flex', flexDirection:'row', marginLeft:'0.5em'}}
            >
              <FormControlLabel value="true" control={<Radio sx={{
                  color:'#f19100',
                  '&.Mui-checked': {
                    color: '#f19100',
                  }
                  }}/>} label="Yes"/>
              <FormControlLabel value="false" control={<Radio sx={{
                  color:'#f19100',
                  '&.Mui-checked': {
                    color: '#f19100',
                  }
                  }}/>} label="No" />
            </RadioGroup>
          </FormControl>
    )
}

registerBrick('017e485409a9388436dc', SKURadioButtonGroup);
